export default __webpack_public_path__ + "static/media/IMG-20230719-WA0002 - 070 Bhavya Gevariya.500aa9f1.jpg";